// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2X_hB","description":"PatientConsentPreview_description__DuVb2"};